import React, { useState } from 'react';
import { WizardItem } from '../../../Interfaces/Wizard.interface';
import { WizardItemType } from '../../../Enums/WizardItemType.enum';
import PartnerWorkplaceSelectField from '../../../../BaseModule/Components/Form/Components/PartnerWorkplaceSelect/PartnerWorkplaceSelectField';
import WorkplaceUserSelectField from '../../../../BaseModule/Components/Form/Components/WorkplaceUserSelect/WorkplaceUserSelectFiled';
import { WorkplaceUserSelectType } from '../../../../BaseModule/Components/Form/Components/WorkplaceUserSelect/WorkplaceUserSelect';
import { SelectValue } from '../../../../BaseModule/Components/Select/Select';
import FormContainer from '../../../../BaseModule/Components/Form/Components/FormContainer/FormContainer';

interface Props {
	item: Extract<WizardItem, { type: WizardItemType.USER_RELATIONS }>;
}

const WizardUserRelations: React.FC<Props> = ({ item }) => {
	const [workplaceId, setWorkplaceId] = useState<string | undefined>(undefined);

	return (
		<FormContainer name='userRelation'>
			<PartnerWorkplaceSelectField
				name='workplaceId'
				label='base.shared.ambulanceName'
				partnerId={item.settings.partnerId}
				onChange={(value: SelectValue) => setWorkplaceId(value.value as string)}
				isRequired
				isWrapped
				portal
			/>
			<WorkplaceUserSelectField
				name='doctorId'
				label='base.doctorName'
				placeholder='base.shared.enterSurnameOfDoctorWhichYouAreLookingFor'
				workplaceId={workplaceId}
				type={WorkplaceUserSelectType.DOCTOR}
				isRequired
				isWrapped
				portal
			/>
		</FormContainer>
	);
};

export default WizardUserRelations;
